import $ from 'jquery';
import debounce from './utils/debounce';

class Header {
    constructor(mobileBreakpoint) {
        this.$document = $(document);
        this.$window = $(window);
        this.speed = 200;
        this.$body = $('body');
        this.mobileBreakpoint = mobileBreakpoint;

        // Header
        this.$header = $('.js-header');
        this.$headerObserver = $('.js-header-observer');
        this.$toc = $('.js-table-of-contents');
        this.stickyHeader();

        // Search
        this.$searchForm = $('.js-search-form');
        this.$searchField = $('.js-search-field');
        this.$searchOpenButton = $('.js-search-open');
        this.$searchCloseButton = $('.js-search-close');

        // Burger Menu
        this.$burgerButton = $('.js-burger-button');
        this.$burgerContent = $('.js-burger-content');
        this.$chevrons = $('.js-menu-item-expand');
        this.$mainMenu = $('.js-main-menu');

        // Mobile Menu Events
        this.$chevrons.on('click', $.proxy(this.toggleSubMenu, this));

        // Search Events
        this.$searchOpenButton.on('click', $.proxy(this.openSearch, this));
        this.$searchCloseButton.on('click', $.proxy(this.closeSearch, this));

        this.$document.keyup((e) => {
            // Escape Key
            if (e.keyCode === 27) {
                this.closeSearch();
            }
        });

        // Burger Events
        this.$burgerButton.on('click', $.proxy(this.burgerToggle, this));

        this.$window.on('resize', debounce(() => {
            if (this.$window.width() > this.mobileBreakpoint) {
                this.resetEverything();
            }

            if (this.$window.width() < this.mobileBreakpoint) {
                this.$header.removeClass('is-sticky');
            }
        }, 300));
    }

    closeSearch(e) {
        if (typeof e !== 'undefined') {
            e.preventDefault();
        }

        this.$searchForm.fadeOut(this.speed).removeClass('is-open');
        this.$header.removeClass('search-is-open');
        this.$body.removeClass('has-overlay is-scroll-locked');
    }

    openSearch() {
        this.$searchForm.addClass('is-open').fadeIn(this.speed, () => {
            this.$searchField.focus();
        });

        this.$header.addClass('search-is-open');
        this.$body.addClass('has-overlay is-scroll-locked');
    }

    burgerToggle() {
        // setting the aria attribute to true when clicking on the button
        this.$burgerButton.attr('aria-expanded', 'true');

        this.$burgerButton.toggleClass('is-open').next(this.$burgerContent).toggleClass('is-visible');
        // this.$burgerContent.slideToggle(this.speed);

        $('body').toggleClass('is-scroll-locked');

        // if the burger doesn't have the class 'is-open' then the aria attribute is set to false
        if (!this.$burgerButton.hasClass('is-open')) {
            this.$burgerButton.attr('aria-expanded', 'false');
        }
    }

    toggleSubMenu(e) {
        const $elem = $(e.currentTarget);

        $elem.toggleClass('is-open');

        if ($elem.hasClass('is-open')) {
            $elem.attr('aria-expanded', 'true');
        } else {
            $elem.attr('aria-expanded', 'false');
        }

        $elem.parent().next().slideToggle(this.speed);
    }

    resetEverything() {
        // Close
        this.closeSearch();

        // Reset Burger Menu
        this.$burgerButton.removeClass('is-open');
        this.$burgerContent.removeAttr('style');
        $('body').removeClass('is-scroll-locked');
    }

    stickyHeader() {
        const contentObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting === false && entry.boundingClientRect.y < 0) {
                    this.$header.addClass('is-sticky');
                    this.$toc.addClass('under-sticky-header');
                    $('body').addClass('is-sticky');
                } else {
                    this.$header.removeClass('is-sticky');
                    this.$toc.removeClass('under-sticky-header');
                    $('body').removeClass('is-sticky');
                }
            });
        });
        contentObserver.observe(this.$headerObserver[0]);
    }
}

export default Header;
